export default "__VITE_ASSET__B5_MJo4o__"